import {WriteButton} from '../../../common/buttons/WriteActions';
import {mobileDialogSx} from '../../../common/dialogs/mobileDialogSx';
import {Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography,} from "@mui/material";
import {useState} from "react";
import {useAppTranslation} from "@mybake/ui/hooks/useAppTranslation";

interface Props {
    open: boolean;
    onClose: () => void;
    name: string;
    onDelete: () => boolean | void | Promise<boolean | void>;
    error?: string;
}

export const DeletePackageDialog = ({
                                        open,
                                        onClose,
                                        name,
                                        onDelete,
                                        error,
                                    }: Props) => {
    const {t} = useAppTranslation();
    const [confirmationText, setConfirmationText] = useState("");
    const [deleting, setDeleting] = useState(false);

    const isValid =
        confirmationText.trim() === name.trim();

    const handleClose = () => {
        setConfirmationText("");
        onClose();
    };

    const handleDelete = async () => {
        setDeleting(true);
        try {
            if (await onDelete()) handleClose();
        } finally {
            setDeleting(false);
        }
    };

    return (
        <Dialog sx={mobileDialogSx} open={open} onClose={handleClose}>
            <DialogTitle>{t('items:delete_package')}</DialogTitle>

            <DialogContent>
                <Typography sx={{mb: 2}}>
                    {t('items:delete_package_confirmation')}
                </Typography>

                <Typography
                    color="error"
                    fontWeight={600}
                    sx={{mb: 2}}
                >
                    {name}
                </Typography>

                <TextField
                    fullWidth
                    label={t('items:package_name')}
                    value={confirmationText}
                    onChange={(e) =>
                        setConfirmationText(e.target.value)
                    }
                />
                {error && <Alert severity="error" sx={{mt: 2}}>{error}</Alert>}
            </DialogContent>

            <DialogActions>
                <Button onClick={handleClose} disabled={deleting}>
                    {t('common:cancel')}
                </Button>

                <WriteButton
                    color="error"
                    variant="contained"
                    disabled={!isValid || deleting}
                    onClick={handleDelete}
                >
                    {t('common:delete')}
                </WriteButton>
            </DialogActions>
        </Dialog>
    );
};
